export const convertSecondsToHours = (valueInSeconds: number): number => {
    return valueInSeconds / 3600; // Convert seconds to hours
  };
  
export const convertSecondsToHHMMSS = (valueInSeconds: number): string => {
    const hours = Math.floor(valueInSeconds / 3600);
    const minutes = Math.floor((valueInSeconds % 3600) / 60);
    const seconds = Math.round(valueInSeconds % 60)
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  };
  
export const convertHoursToSecForApi = (valueInHours: number): number => {
    return valueInHours * 3600; // Convert hours to seconds
  };
  
export const convertHHMMSSToSecForApi = (valueInHHMMSS: string): number => {
    const [hours, minutes, seconds] = valueInHHMMSS.split(":").map(Number);
    return (hours * 3600) + (minutes * 60) + seconds; // Convert HH:MM:SS to seconds
  };
  